<div class="d-flex border-top flex-wrap justify-content-between">
  <era-device-mdm-sync-force></era-device-mdm-sync-force>

  <div>
    <span class="btn btn-sm">Actions:</span>
    <era-device-mdm-sync-retry-ui [deviceSyncStatus]="deviceStatus()"
                                  (retry)="retry($event)">
    </era-device-mdm-sync-retry-ui>
  </div>
</div>